"use client";
import React from "react";

interface PostHeadingProps {
  title: string;
  colorCode?: string;
  subcatTitle?: string;
  detailCatId: string;
  getData: () => Promise<void>;
  setLike: (value: boolean) => void;
  like: boolean;
  heart: boolean;
  setHeart: (value: boolean) => void;
  ip: string;
}

const PostHeading: React.FC<PostHeadingProps> = ({
  title,
  colorCode,
  subcatTitle,
  detailCatId,
  getData,
  setLike,
  like,
  heart,
  setHeart,
  ip,
}) => {
  return (
    <>
      <div className="mb-0 flex justify-between md:mb-4">
        <div className="flex h-12 items-center">
          <span
            className={`rounded px-5 py-2 text-xs font-semibold text-black`}
            style={{ backgroundColor: colorCode || "#f0f0f0" }}
          >
            {subcatTitle || "Blog Post"}
          </span>
        </div>
      </div>
      <div>
        <h1 className="main-bd-h1 mb-2 text-[32px] font-semibold text-black sm:mb-5 lg:text-[40px]">
          {title}
        </h1>
      </div>
    </>
  );
};

export default PostHeading;
